import { render, staticRenderFns } from "./SingpassSuccess.vue?vue&type=template&id=5bd6aaeb&"
import script from "./SingpassSuccess.vue?vue&type=script&lang=js&"
export * from "./SingpassSuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports